import React, {useEffect} from 'react';
import '../../App.css';
import Footer from '../Footer';

function AboutMe() {
    useEffect(() => {
                const timer = setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    }, 50);
        
                return () => clearTimeout(timer);
    }, []);
    return (
        <>
        <h1 className='about-me-hero'>About Me</h1>
        <h1 className="text">Who Am I?</h1>
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
        <img
            className="container-image"
            src="/images/img-headshot.JPG"
            alt="Vanson Nguyen"
        />
        </div>
        <div className="content-container">
            <div className="container-text">
                <p className="text">
                    My name is Vanson Nguyen and I am currently a candidate for a MSc, Business Analytics at Ivey Business School.
                    I completed my undergraduate degree in Computer Science and Biochemistry at Western University.
                    In 2023, I picked up my father's old photography gear and began my own journey. 
                    This website is a visual representation of what I've learned, and it will continue to develop as I grow as a photographer and a person.
                </p>
            </div>
        </div>
        <h1 className="text">My Philosophy</h1>
        <p className="text">
            I believe that there is beauty in anything and everything.
            My approach focuses on revealing the unique brilliance of each subject I photograph.
            Rather than imposing a fixed aesthetic, I allow the subject to guide the style.
            Every subject is distinct, and every image should reflect that individuality.
            Thus, I capture and edit every photo with intention and care.
        </p>

        <p className='bottom-space' />

        <Footer />
        </>
    );
}

export default AboutMe
